import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import { fetchPrice } from '../../features/prices/actions';
import { RootState } from '../../config/redux/types';
import { PriceSuggestion } from '../../routes/reducers/types';

interface PriceHookResult {
  loading: boolean;
  matchingPrice?: PriceSuggestion;
  alternativePrices: PriceSuggestion[];
  hasMatchingPrice: boolean;
}

// eslint-disable-next-line import/prefer-default-export
export function usePriceFetcher(accommodationId?: number): PriceHookResult {
  const arrival = useSelector((state: RootState) => state?.request?.arrival);
  const durationOfStay = useSelector((state: RootState) => state?.request?.durationOfStay);
  const prices = useSelector((state: RootState) => state.prices);
  const dispatch = useDispatch();

  useEffect(() => {
    if (accommodationId == null) {
      return;
    }

    const arrivalString = arrival && arrival.isValid() ? moment(arrival).toISOString() : undefined;
    if (accommodationId != null) {
      dispatch(fetchPrice(accommodationId, arrivalString, durationOfStay));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accommodationId, arrival, durationOfStay]);

  const loading = _.includes(prices.loading, accommodationId);
  const matchingPrice =
    (accommodationId != null &&
      prices[accommodationId] &&
      prices[accommodationId].matchingSuggestion) ||
    undefined;
  const alternativePrices =
    (accommodationId != null &&
      prices[accommodationId] &&
      prices[accommodationId].alternativeSuggestions) ||
    [];
  const hasMatchingPrice =
    matchingPrice != null && typeof matchingPrice !== 'boolean' && matchingPrice.price != null;

  return {
    loading,
    matchingPrice,
    alternativePrices,
    hasMatchingPrice,
  };
}
